import { Container } from "@mui/material";
import { RecruitmentProcess } from "styles/jss/JobSeekers.styles";
import {
  AcceptIcon,
  BriefCase,
  ChecklistIcon,
  InterviewIcon,
  PcycologyIcon,
  PhoneIntIcon,
  ResumeIcon,
  SocietyIcon,
} from "../../IconsSvg";
import { useTranslation } from "next-i18next";

export default function JobSeekRecruitmentProcess() {
  const { t } = useTranslation(["common"]);
  const RP_DATA = [
    {
      title: t("jobSeekers.process.1.title"),
      subtitle: t("jobSeekers.process.1.subtitle"),
      icon: <ResumeIcon />,
    },
    {
      title: t("jobSeekers.process.2.title"),
      subtitle: t("jobSeekers.process.2.subtitle"),
      icon: <ChecklistIcon />,
    },
    {
      title: t("jobSeekers.process.3.title"),
      subtitle: t("jobSeekers.process.3.subtitle"),
      icon: <PhoneIntIcon />,
    },
    {
      title: t("jobSeekers.process.4.title"),
      subtitle: t("jobSeekers.process.4.subtitle"),
      icon: <InterviewIcon />,
    },
    {
      title: t("jobSeekers.process.5.title"),
      subtitle: t("jobSeekers.process.5.subtitle"),
      icon: <PcycologyIcon />,
    },
    {
      title: t("jobSeekers.process.6.title"),
      subtitle: t("jobSeekers.process.6.subtitle"),
      icon: <AcceptIcon />,
    },
    {
      title: t("jobSeekers.process.7.title"),
      subtitle: t("jobSeekers.process.7.subtitle"),
      icon: <BriefCase />,
    },
    {
      title: t("jobSeekers.process.8.title"),
      subtitle: t("jobSeekers.process.8.subtitle"),
      icon: <SocietyIcon />,
    },
  ];

  return (
    <RecruitmentProcess>
      <Container>
        <h2>{t("jobSeekers.process.title")}</h2>
        <div className={"timeLine"}>
          {RP_DATA.map(({ title, subtitle, icon }, index) => (
            <div key={index} className={"item"}>
              <i>{icon}</i>
              <h3>{title}</h3>
              <p>{subtitle}</p>
            </div>
          ))}
        </div>
      </Container>
    </RecruitmentProcess>
  );
}
